<template>
  <div id="app">
    <div class="headerBoxs">
      <img class="headerBoxsimg" src="../../static/img/banner3.jpg" alt=""/>
    </div>
    <div class="headerBoxss">
      <div class="headerBox">
        <el-menu
            class="el-menu-demo"
            mode="horizontal"
            background-color="#2F7AF4"
            text-color="#fff"
            active-text-color="#409EFF"
            :default-active="activeIndex"
            router
        >
          <el-menu-item index="/home_page">
            首页
          </el-menu-item>
          <el-menu-item index="/public_announcement">
            通知公告
          </el-menu-item>
          <el-menu-item index="/download_center">
            标准与指南
          </el-menu-item>
          <el-menu-item index="/subject_area">
            课题研究
          </el-menu-item>
          <el-menu-item index="/case_share">
            案例分享
          </el-menu-item>
          <el-menu-item index="/answer_questions">
            常见问题
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // 组件名字
  name: "App",
  // 状态数据
  data() {
    return {activeIndex: "/home_page"};
  },
  created() {
    if (this.$route.path == "/smart_drains" || this.$route.path == 'smart_drainst') {
      this.activeIndex = "/public_announcement";
    } else if (this.$route.path == "/smart_drain") {
      this.activeIndex = "/answer_questions";
    } else {
      this.activeIndex = this.$route.path
    }
  },
  watch: {
    $route: {
      handler(newValue, oldValue) {
        if (newValue.path == "/smart_drains" || newValue.path == 'smart_drainst') {
          this.activeIndex = "/public_announcement";
        } else if (newValue.path == "/smart_drain") {
          this.activeIndex = "/answer_questions";
        } else {
          this.activeIndex = newValue.path;
        }
      },
      // 深度侦听需要遍历被侦听对象中的所有嵌套的属性，当用于大型数据结构时，开销很大。
      // 因此请只在必要时才使用它，并且要留意性能。
      deep: true,
    },
  },
};
</script>
<style lang="less">
.el-menu-item.is-active {
  color: #fff !important; /* 选中后字体颜色为白色 */
  background-color: #235ae7 !important; /* 选中后底部颜色为蓝色 */
}

a {
  padding: 35px 40px;
}

#app {
  width: 100%;

  .headerBoxs {
    width: 100%;

    .headerBoxsimg {
      width: 100%;
      background-size: cover;
      background-position: center;
      vertical-align: middle;
    }
  }

  // 顶部logo
  .headerBoxss {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: space-evenly;
    background: #2f7af4;

    .headerBox {
      display: flex;

      align-items: center;
      width: 1345px;
      height: 64px;

      border-radius: 0px 0px 0px 0px;
      opacity: 0.92;
      overflow: hidden;

      .el-menu.el-menu--horizontal {
        border: none;
      }

      .el-menu-item {
        text-align: center;
        line-height: 80px;
        width: 200px;
        height: 80px;
        font-size: 26px;
        cursor: pointer;
        font-weight: 700;
      }

      .custom-visited {
        background-color: #7b0404;
      }

      a {
        text-decoration: none;
      }
    }
  }
}
</style>
